var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"items":_vm.fieldType.fields,"fields":_vm.fields,"small":""},scopedSlots:_vm._u([{key:"cell(name)",fn:function(ref){
var item = ref.item;
return [_c('FieldName',{attrs:{"field":item}})]}},{key:"cell(description)",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"text-muted small"},[_c('div',{staticClass:"description"},[_vm._v(_vm._s(item.description))]),(item.isDeprecated && item.deprecationReason.length)?_c('div',{staticClass:"deprecated mt-1"},[_vm._v("Deprecated: "+_vm._s(item.deprecationReason))]):_vm._e()])]}},{key:"cell(arguments)",fn:function(ref){
var item = ref.item;
return _vm._l((item.args),function(arg,i){return _c('FieldArg',{key:i,staticClass:"small",class:{'mt-2': i},attrs:{"arg":arg}})})}},{key:"cell(null)",fn:function(ref){
var item = ref.item;
return [(item.type.nullable)?_c('b-icon-check'):_c('b-icon-x')]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }